import clsx from 'clsx';

import { useCurrentUser, useView } from '@/hooks';

import Cards from './Cards';
import CoachBookingCards from './Cards/CoachBookingCards';
import { HomeCardsProvider } from './Cards/HomeCardsContext';
import Coachees from './Coachees';
import Coaches from './Coaches';
import HeroBanner from './HeroBanner';
import Mindset from './Mindset';
import MomentsIntroBanner from './MomentsIntroBanner';
import MomentsPromoBanner from './MomentsPromoBanner';
import OnboardingFlow from './OnboardingFlow';
import OnboardingReviewBanner from './OnboardingReviewBanner';
import PendingDebriefBanners from './PendingDebriefBanners';
import Session from './Session';
import SessionReflections from './SessionReflections';
import WelcomeMessage from './WelcomeMessage';

import LoadingCover from '@/components/Layouts/Loading';

const Home = () => {
  // Client layout is full screen, coach is not
  // If design can make these consistent, we can remove this
  const { isClient } = useView();
  const { user, isError, isUserLoading } = useCurrentUser();

  // Retained identity after a failed refetch must not admit member data.
  if (isClient && (isUserLoading || isError || !user.id)) {
    return <LoadingCover />;
  }

  return (
    <>
      <div className="z-10 flex flex-1 flex-col py-4 pl-4 md:py-6 md:pl-6">
        <div className="-ml-4 -mt-4 pb-8 pl-4 pt-4 md:-ml-6 md:-mt-6 md:pl-6 md:pt-6">
          <div className="flex justify-between">
            <div className="flex flex-row gap-2">
              <Mindset />
              <Coaches />
            </div>
          </div>
        </div>
        <div
          className={clsx(
            'container z-10 max-w-full flex-1 flex-col justify-center md:flex',
            {
              'mx-auto max-w-screen-lg pr-4': !isClient,
            },
          )}
        >
          <WelcomeMessage />
          {!isClient && <MomentsPromoBanner />}
          {/* Members see the full-width coach booking CTA directly under the
              greeting, above Moments and the "For you" carousel. One provider
              so both card blocks share a single card list and clock. */}
          {!!isClient && (
            <HomeCardsProvider>
              <OnboardingReviewBanner />
              <CoachBookingCards />
              <MomentsIntroBanner />
              <SessionReflections />
              <Cards />
            </HomeCardsProvider>
          )}
          <HeroBanner />
          <Session />
          <PendingDebriefBanners />
          <Coachees />
        </div>
      </div>
      <OnboardingFlow />
    </>
  );
};

export default Home;
